import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { getOrgTermsContent } from '../../../content/utils.js';
import FieldGroup from '../../FieldGroup.jsx';
import DatePickerAdapter from '../../DatePickerAdapter.jsx';
import { FormError } from '../../FormError.jsx';
import MultistepFormsFooter from '../../MultistepFormsFooter.jsx';
import MultistepFormsNav from '../../headers/FormHeaders/MultistepFormsNav.jsx';
import { momentToDateString, stringToMoment } from '../../../lib/utils.js';

const StepMilestonesFrom = (props) => {
  const {
    entities,
    submitError,
    submitFailed,
    loading,
    handleSubmit,
    onCreateMilestone,
    onDeleteMilestone,
    onFieldChange,
    values,
    onCancel,
    onBack,
  } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <MultistepFormsNav
            activeIndex={2}
            onBack={onBack}
            onSubmit={handleSubmit}
            type="portfolio"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={8}>
          <p className="communication-help text-muted m-b-24">
            {getOrgTermsContent('portfolioMilestonesFormDescription')}
          </p>
        </Col>
      </Row>

      <Row className="m-b-60">
        <Col xs={12}>
          {entities.map(({ id, tempId }, index) => (
            <React.Fragment key={`add-milestone-form-${id || tempId}`}>
              <Row>
                <Col xs={6}>
                  <div className="milestone-form">
                    <Field
                      id={`name${index}`}
                      name={`name${index}`}
                      label={`${index + 1} ${getOrgTermsContent('portfolio')} Milestone`}
                      placeholder="Milestone Title"
                      type="text"
                      component={FieldGroup}
                    >
                      {(props) => (
                        <FieldGroup
                          {...props}
                          value={entities[index].name || ''}
                          onChange={(e) =>
                            onFieldChange(index, 'name', e.target.value)
                          }
                        />
                      )}
                    </Field>
                    <button
                      type="button"
                      className="btn-delete btn btn-default m-t-28"
                      onClick={() =>
                        onDeleteMilestone(id ? 'id' : 'tempId', id || tempId)
                      }
                    ></button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <Field
                    id={`date_at${index}`}
                    name={`date_at${index}`}
                    label="Date"
                    placeholderText="Click to select"
                    component={DatePickerAdapter}
                    input={{ value: stringToMoment(entities[index].date_at) }}
                    onChange={(val) =>
                      onFieldChange(index, 'date_at', momentToDateString(val))
                    }
                    allowNull
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={6} className="m-b-10">
                  <Field
                    id={`notes${index}`}
                    name={`notes${index}`}
                    componentClass="textarea"
                    rows={5}
                    className="m-0"
                    customClass="fixed-height"
                    placeholder="Enter a Value"
                    type="text"
                    label="Note"
                  >
                    {(props) => (
                      <FieldGroup
                        {...props}
                        value={entities[index].notes}
                        onChange={(e) =>
                          onFieldChange(index, 'notes', e.target.value)
                        }
                      />
                    )}
                  </Field>
                </Col>
              </Row>
            </React.Fragment>
          ))}
        </Col>
        <Col xs={12}>
          <button
            disabled={entities.length && entities.some((item) => !item.name)}
            type="button"
            className="btn-link"
            onClick={onCreateMilestone}
          >
            {' '}
            + Add a Milestone
          </button>
        </Col>
      </Row>
      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
      </Row>
      <Row>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={loading}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
          />
        </Col>
      </Row>
    </form>
  );
};

export default StepMilestonesFrom;
